import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';

import { FeatureFlags } from '../models/FeatureFlags';
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagApiService {
  private readonly resourceUrl = '/configuration/frontend/feature-flags';

  constructor(private apiService: ApiService) {}

  getFeatureFlags(): Observable<any> {
    return this.apiService.get(`${this.resourceUrl}`);
  }

  setFeatureFlags(req: FeatureFlags): Observable<any> {
    return this.apiService.put(`${this.resourceUrl}`, req);
  }
}
